import React from 'react';
import get from 'lodash/get';

import "./html-snippet.m.css";

class HtmlSnippet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: ''
    };
  }

  componentDidMount() {
    this.props.bannerSource && this.getBannerData();
  }

  componentDidUpdate(prevProp) {
    if(prevProp.bannerSource !== this.props.bannerSource) {
      this.getBannerData();
    }
  }

  async getBannerData() {
    const url = `/api/v1/custom-urls/${encodeURIComponent(this.props.bannerSource)}`;
    const bannerData = await (await fetch(url)).json();
    this.setState({
      bannerData: get(bannerData, ['page', 'content'], '')
    });
  }

  render() {
    if(!this.state.bannerData) {
      return null;
    }
    return <div styleName="snippet-wrapper" dangerouslySetInnerHTML={ {__html: this.state.bannerData }}></div>;
  }
}

export { HtmlSnippet };